import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LayerBackendService } from 'src/app/shared/services/layer-backend.service';

import { GetDeliveryResponse } from './delivery-service.model';
import { DeliveryLine, DeliveryTableLine } from '../models/delivery.model';

@Injectable({
  providedIn: 'root',
})
export class DeliveryService {
  protected get baseUrl(): string {
    return this.backend.deliveryLineBaseUrl;
  }

  constructor(
    protected http: HttpClient,
    private readonly backend: LayerBackendService,
  ) {}

  getDeliveries(
    startDate?: string,
    endDate?: string,
    locations?: number[],
  ): Observable<DeliveryLine[] | HttpErrorResponse> {
    let params = {};
    if (!!startDate && !!endDate) {
      params = {
        startDate,
        endDate,
      };
    }
    if (!!locations && locations.length > 0) {
      params = {
        ...params,
        LocationIds: locations,
      };
    }
    return this.http.get<GetDeliveryResponse>(`${this.baseUrl}`, { params }).pipe(
      map((response) => response.deliveryLines),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of(<DeliveryLine[]>[]);
        } else {
          return throwError({ message: error.message });
        }
      }),
    );
  }

  upsertDelivery(delivery: DeliveryTableLine): Observable<unknown | HttpErrorResponse> {
    return this.http
      .patch(`${this.baseUrl}/${delivery.id}`, {
        isActive: delivery.isActive,
        locationId: delivery.locationId,
        flock: delivery.flock,
      })
      .pipe(
        map((d) => d),
        catchError((error: HttpErrorResponse) => {
          if (error.status === 404) {
            return of({});
          } else {
            return throwError({ message: error.message });
          }
        }),
      );
  }
}
